import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState, useEffect } from 'react';
import Icon from '../../../../core/Icon';
import { Grid, Typography, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import Formatter from '../../../../formatter';
var useStyles = makeStyles(function (theme) {
  return {
    loadingIndicator: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginLeft: '-25px',
      marginTop: '-25px'
    },
    iconInfo: {
      verticalAlign: 'middle',
      color: theme.common.intention.success
    },
    iconWarn: {
      verticalAlign: 'middle',
      color: theme.common.intention.warning
    },
    typographyPart: {
      display: 'inline-block'
    }
  };
}, {
  name: 'ECImdbStatus'
});

var ImdbStatus = function ImdbStatus(_ref) {
  var stage = _ref.stage,
      error = _ref.error,
      lastModified = _ref.lastModified; // used to rerender content to update duration

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      ticks = _useState2[0],
      setTicks = _useState2[1];

  useEffect(function () {
    var intervalID = setInterval(function () {
      return setTicks(ticks + 1);
    }, 60000);
    return function () {
      return clearInterval(intervalID);
    };
  }, []);
  var classes = useStyles({});

  if (stage === 'Starting' || stage === 'Processing') {
    return React.createElement(Grid, {
      container: true,
      alignItems: "center",
      spacing: 1
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      type: "warning",
      className: classes.iconWarn
    })), React.createElement(Grid, {
      item: true,
      xs: true
    }, React.createElement(Typography, null, "The data is being refreshed in the background.")));
  }

  if (!stage) return React.createElement(CircularProgress, {
    className: classes.loadingIndicator
  });
  if (error) return React.createElement(Typography, {
    color: "error"
  }, error);
  var durationSinceRefresh = moment.duration( // need the nagative duration to format with the correct suffix
  // eg: 1 day ago
  -1 * (new Date().getTime() - lastModified.getTime()));
  var isStale = durationSinceRefresh.asMinutes() < -15;
  return React.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 1
  }, React.createElement(Grid, {
    item: true
  }, isStale ? React.createElement(Icon, {
    type: "warning",
    className: classes.iconWarn
  }) : React.createElement(Icon, {
    type: "info",
    className: classes.iconInfo
  })), React.createElement(Grid, {
    item: true,
    xs: true
  }, isStale && React.createElement(Typography, null, "Last refreshed ".concat(durationSinceRefresh.humanize(true), ". Hit refresh to see the latest data.")), !isStale && React.createElement(React.Fragment, null, React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    className: classes.typographyPart
  }, "As of\xA0")), React.createElement(Grid, {
    item: true
  }, React.createElement(Formatter.DateTime, {
    value: lastModified,
    format: "MMM DD, YYYY h:mm A"
  }))))));
};

export default ImdbStatus;